export const CHECKOUT_MESSAGES = {
  pageTitle: 'Finalizar Compra',
  loginSection: {
    title: 'Quase lá! Entre ou crie sua conta',
    description:
      'Seus dados de pagamento já estão preenchidos. Faça login ou crie uma conta para concluir a compra.',
  },
};
